import type { Tables } from '@/shared/types/tables';
import type { NotificationPrefs, Profile } from './types';

/** "Aleksandra Golobokova" → "AG"; single word → first two letters. */
export function initialsFromName(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  const first = words[0] ?? '';
  const last = words[words.length - 1] ?? '';
  const initials = words.length === 1 ? first.slice(0, 2) : first.charAt(0) + last.charAt(0);
  return initials.toUpperCase() || '?';
}

export function mapProfile(row: Tables<'profiles'>): Profile {
  return {
    id: row.id,
    name: row.name,
    initials: row.initials,
    avatarColor: row.avatar_color,
    avatarUrl: row.avatar_url,
    bio: row.bio,
    website: row.website,
    twitter: row.twitter,
    linkedin: row.linkedin,
    role: row.role,
  };
}

export function mapNotificationPrefs(row: Tables<'notification_prefs'>): NotificationPrefs {
  return {
    reply: row.reply,
    newsletter: row.newsletter,
    newArticle: row.new_article,
    weeklyDigest: row.weekly_digest,
  };
}
